import {safeParseJson, findParent} from '../../js/tools';

export class Gallery {
  elements = {
    root: null,
    leftArrow: null,
    rightArrow: null,
    mainImage: null,
    loadingIndicator: null,
    numberIndicator: null,
    itemElements: null,
  };
  state = {
    type: null,
    selectedIndex: 0,
    isImageLoading: false,
  };
  model = null;

  constructor(element) {
    if (!element) {
      return;
    }

    this.model = safeParseJson(element.dataset.model) || {};
    this.elements = {
      root: element,
      leftArrow: element.querySelector('.left-arrow'),
      rightArrow: element.querySelector('.right-arrow'),
      mainImage: element.querySelector('.main-image'),
      loadingIndicator: element.querySelector('.loading-indicator'),
      numberIndicator: element.querySelector('.number-indicator'),
      itemElements: document.querySelectorAll(this.model.itemElement),
    };

    this.addEventListeners();
    this.updateState();
  }

  get imageCount() {
    return this.model.images?.length;
  }

  get shouldLoop() {
    return this.model.shouldLoop || false;
  }

  getAncestors(element, ancestors = []) {
    const parent = element.parentElement;
    if (parent) {
      ancestors.push(parent);
      this.getAncestors(parent, ancestors);
    }
    return ancestors;
  }

  findBySelector(elements, selector) {
    return elements.find(element => element.matches(selector));
  }

  addEventListeners() {
    this.elements.mainImage?.addEventListener('load', (event) => {
      this.updateState((state) => {
        state.isImageLoading = false;
      });
    });

    this.elements.root.addEventListener('click', (event) => {
      const elements = [
        event.target,
        ...this.getAncestors(event.target),
      ];
      const leftArrow = this.findBySelector(elements, '.left-arrow');
      const rightArrow = this.findBySelector(elements, '.right-arrow');

      if (leftArrow) {
        this.left();
      } else if (rightArrow) {
        this.right();
      }
    });

    // Trigger can be a single element or multiple.
    // If multiple, use event delegaton.
    if (this.elements.itemElements.length) {
      if (this.elements.itemElements.length > 1) {
        document.addEventListener('click', (event) => {
          const match = findParent(event.target, this.model.itemElement);
          if (match) {
            this.setIndex(Number.parseInt(match.dataset.index));
          }
        });
      } else {
        this.elements.itemElements[0].addEventListener('click', () => {
          this.toggle();
        });
      }
    }
  }

  left() {
    if (!this.shouldLoop && this.state.selectedIndex === 0) {
      return;
    }

    this.updateState((state) => {
      state.selectedIndex--;
      if (state.selectedIndex < 0) {
        state.selectedIndex = this.imageCount - 1;
      }
    });
  }

  right() {
    if (!this.shouldLoop && this.state.selectedIndex === this.imageCount - 1) {
      return;
    }

    this.updateState((state) => {
      state.selectedIndex++;
      if (state.selectedIndex > this.imageCount - 1) {
        state.selectedIndex = 0;
      }
    });
  }

  setIndex(index) {
    this.updateState((state) => {
      state.selectedIndex = index;
    });
  }

  updateState(callback = () => {}) {
    /*
    Always update the state by calling this method.
    */
    callback(this.state);
    // console.log('Gallery', this); // @jk save for debugging

    const imageSrc = this.model.images[this.state.selectedIndex];

    this.addDataToMainImage();

    // must not load if the src is the same (recursive loop)
    if (encodeURI(imageSrc) !== this.elements.mainImage.src) {
      this.elements.mainImage.src = imageSrc;
      this.state.isImageLoading = true;
    }

    if (this.elements.leftArrow && this.elements.rightArrow) {
      if (this.imageCount < 2) {
        this.elements.leftArrow.style.visibility = 'hidden';
        this.elements.rightArrow.style.visibility = 'hidden';
      } else {
        this.elements.leftArrow.style.visibility = 'visible';
        this.elements.rightArrow.style.visibility = 'visible';
      }
    }

    if (!this.shouldLoop && this.state.selectedIndex === 0) {
      this.elements.leftArrow.style.visibility = 'hidden';
    }
    if (!this.shouldLoop && this.state.selectedIndex === this.imageCount - 1) {
      this.elements.rightArrow.style.visibility = 'hidden';
    }

    if (this.elements.loadingIndicator) {
      if (this.state.isImageLoading) {
        this.elements.loadingIndicator.style.opacity = 1;
      } else {
        this.elements.loadingIndicator.style.opacity = 0;
      }
    }

    if (this.elements.numberIndicator) {
      this.elements.numberIndicator.innerText = `${this.state.selectedIndex + 1}/${this.imageCount}`;
    }
  }

  addDataToMainImage() {
    const orientation = this.getImageOrientation(this.elements.mainImage);
    this.elements.mainImage.dataset.orientation = orientation;
  }

  getImageOrientation(image) {
    let orientation = 'horizontal';

    const rect = {
      width: image.naturalWidth,
      height: image.naturalHeight,
    };
    console.log({rect});

    if (rect.height > rect.width) {
      orientation = 'vertical';
    }

    return orientation;
  }
}
